import { findLayer, refreshLayerMetadata } from '@/map/layers/registry';
import type { Tool } from './types';

type Input = { layer_id: string };

export const refreshLayerMetadataTool: Tool<Input> = {
  name: 'refresh_layer_metadata',
  description:
    'Force a re-probe of a layer (invalidates the disk cache). Use after a query failed with "unknown field" or when the portal admin renamed/added fields.',
  input_schema: {
    type: 'object',
    properties: { layer_id: { type: 'string' } },
    required: ['layer_id'],
    additionalProperties: false,
  },
  execute: async ({ layer_id }) => {
    await refreshLayerMetadata(layer_id);
    const updated = findLayer(layer_id);
    return {
      id: layer_id,
      status: updated?.status ?? 'error',
      field_count: updated?.probe?.fields.length ?? 0,
    };
  },
};
